import { Directive, HostListener } from '@angular/core';

/**
 * ℹ️ A touch event (touchstart) gets dispatched even if button disabled! That's why we cancel this here.
 */
@Directive({
  selector: '[ccPreventTouchStartWhenDisabled]',
  standalone: true
})
export class PreventTouchStartWhenDisabledDirective {
  @HostListener('touchstart', ['$event'])
  public onTouchStart(event: TouchEvent): void {
    const isTouchTargetDisabled = (event?.touches[0]?.target as HTMLButtonElement)?.disabled;
    if (isTouchTargetDisabled) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  }
}
